import React from "react";
import Logo from "../images/logo-colorido.png";

const Header: React.FC = () => {
  return (
    <section className="bg-white">
      <div className="container flex flex-shrink items-center px-5 py-5 mx-auto lg:px-18 2lg:px-28">
        <div className="flex items-center flex-no-shrink text-white mr-6 w-2/6">
          <img className="w-full lg:w-60" src={Logo} alt="DentalUni" />
        </div>
        <div className="hidden lg:flex w-4/6">
          <div className="flex justify-between">
            <a
              href="https://www.dentaluni.com.br/pagina/historico-e-institucional"
              className="py-2 px-4 text-gray-500 no-underline text-sm"
            >
              A COOPERATIVA
            </a>
            <a
              href="https://www.dentaluni.com.br/blog"
              className="py-2 px-4 text-gray-500 no-underline text-sm"
            >
              BLOG
            </a>
            <a
              href="https://www.planosdentaluni.com.br/ratinho/"
              className="py-2 px-4 text-gray-500 no-underline text-sm"
            >
              PLANOS ODONTOLÓGICOS
            </a>
            <a
              href="https://www.dentaluni.com.br/encontreseudentista"
              className="py-2 px-4 text-gray-500 no-underline text-sm"
            >
              ENCONTRE SEU DENTISTA
            </a>
            <a
              href="https://www.dentaluni.com.br/pagina/ouvidoria-dentaluni"
              className="py-2 px-4 text-gray-500 no-underline text-sm"
            >
              OUVIDORIA
            </a>
            <a
              href="https://www.dentaluni.com.br/pagina/idss"
              className="py-2 px-4 text-gray-500 no-underline text-sm"
            >
              IDSS
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
